import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { GOVERNANCE_BASE_PATH } from '../shared/policies.constants';
import { SETTINGS_PARAM, type SettingsSection } from './settingsSections';

interface SettingsRedirectProps {
  section: SettingsSection;
}

export const SettingsRedirect: React.FC<SettingsRedirectProps> = ({ section }) => {
  const { workspace = '0' } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set(SETTINGS_PARAM, section);
  return <Navigate to={{ pathname: `/${workspace}${GOVERNANCE_BASE_PATH}`, search: `?${params}` }} replace />;
};
